














































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CardTitle from '@/components/common/CardTitle.vue';
import CardDesignPreview from '@/components/apps/CardDesignPreview.vue';
import Apps from '@/store/modules/Apps';
import Decisions from '@/store/modules/Decisions';
import AppsSubscribeButton from '@/components/apps/AppsSubscribeButton.vue';
import AppTemplateCard from '@/components/apps/AppTemplateCard.vue'
import { Urls } from "@/Urls";

const appModule = getModule(Apps);
const decisionsModule = getModule(Decisions);

@Component({
    name: 'CardDesignMainPage',
    components: {
        CardTitle,
        CardDesignPreview,
        AppsSubscribeButton,
        AppTemplateCard
    },
    directives: {},
})
export default class CardDesignMainPage extends Vue {
    private show = false;

    @Prop({default:'100%', type: String})
    width!: string;

    @Prop({default:'100%', type: String})
    height!: string;

    @Prop()
    title: string

    @Prop({default: true, type: Boolean})
    newWindow: boolean;

    @Prop({default: false, type: Boolean})
    decisionTitle!: boolean;

    get decisionName() {
        return decisionsModule.selectedDecision.name;
    }

    get selectedAppId() {
        return appModule.selectedAppId;
    }

    get apps() {
        return appModule.apps;
    }

    get url() {
        return this.$router.currentRoute.path;
    }

    private getAppsUrl(url: string) {
        // console.log(this.url);
        let mainPath:string;
        if(url.substring(0,5).toLowerCase() === Urls.APP_EMBED){
            mainPath = Urls.APP_EMBED;
        }else{
            mainPath = Urls.APP_EMBED;
        }
        // Remove trailing '/' if there
        mainPath = mainPath.charAt(mainPath.length - 1) == '/' ? 
            mainPath.substr(0, mainPath.length - 1) : mainPath;

        let re = new RegExp(
            '^(http:|https:){1}[/]{2}([a-zA-Z0-9.:-]*[/]{0})([/]{1}[aApP]*[/]*){1}'
        );
        if (re.test(url)) {
            url = mainPath + url.replace(re, '/');
            // console.log(url);
            return url;
        } else {
            // console.log(url);
            return mainPath + url;
        }
    }

    private generateLink(item: any) {
        let link = '';
        link = `http${window.location.hostname === 'localhost' ? '' : 's'}://${
            window.location.host
        }`;
        if(item.children && item.children.length > 0) {
            link = `${link}${this.getAppsUrl(item?.children[0].href)}`;
            link = `${link}&homepage=${item.homepage && item.showHomepage}&pinnedLeft=true&appEmbedId=${item.id}&appEmbedMenuId=${item.id}`
            return link
        }
        
    }
}
